import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import './RothConversionConfirmationPage.scss';
import ConfirmationSnapshot from '../../ConfirmationSnapshot/ConfirmationSnapshot';
import { dispatchPageLoad } from '../../../../redux/utils/analytics-helper';
import CheckMark from '../../../Shared/CheckMark/CheckMark';
import { CONFIRM_PATH_SUFFIX } from '../../../../settings/settings';
import { scrollElementIntoFullView } from '../../../../utils/dom-utils';

export class RothConversionConfirmationPage extends Component {
  componentDidMount() {
    ReactDOM.findDOMNode(this).scrollIntoView();
    dispatchPageLoad('Confirmation');
  }

  componentDidUpdate() {
    const { transactions, location, history } = this.props;
    const { pathname } = location || {};
    if (transactions.length === 0 && pathname.endsWith(CONFIRM_PATH_SUFFIX)) {
      history.push(
        pathname.substr(0, pathname.length - CONFIRM_PATH_SUFFIX.length)
      );
    }
  }

  render() {
    const {
      isSalesforceRep,
      customerWebViewEnabled,
      confirmationNumber,
      hasPaperless,
      heroTitle = 'Your roth conversion request is currently pending!',
      tradeDate,
      transactions,
      whatsNext: WhatsNext,
      success,
    } = this.props;
    scrollElementIntoFullView('roth-confirmation-page');
    return (
      <div className="roth-confirmation-page">
        <div className="college-branded-header roth-confirmation-page-background-design">
          <span className="roth-confirmation-page-background-design-inner" />
          <span className="roth-confirmation-page-background-design-watermark" />
        </div>
        <div className="container roth-confirmation-page-confirm-container">
          <div className="roth-confirmation-page-submit-text">
            <div className="roth-confirmation-page-confirm-heading">
              {heroTitle}
            </div>
            <div className="roth-confirmation-page-confirm-subheading">
              Note: We will send you {hasPaperless ? 'an email ' : ' mail '}
              indicating we received your request for this transaction. After
              the transaction is completed, we will send you a Confirmation of
              Activity.
            </div>
          </div>
          <div className="roth-confirmation-page-snapshot-container">
            <ConfirmationSnapshot
              isSalesforceRep={isSalesforceRep}
              customerWebViewEnabled={customerWebViewEnabled}
              id="confirmation-snapshot"
              tradeDate={tradeDate}
              transactions={transactions}
              successIcon={
                <CheckMark className="roth-confirmation-page-checkmark" />
              }
              success={success}
              confirmationNumber={confirmationNumber}
            />
          </div>
        </div>
        {!(!customerWebViewEnabled && isSalesforceRep) && <WhatsNext />}
        <p className="container">2820106</p>
      </div>
    );
  }
}

export default compose(withRouter)(RothConversionConfirmationPage);
